module.exports = __webpack_public_path__ + "assets/img/hots.0e1a76ef.jpg";